<swiper-container #swiperContainer class="grow-intro-swiper" [modules]="swiperModules" [freeMode]="false" [pagination]="true">
  @for (slide of slides; track slide) {
    <swiper-slide>
      <div class="slide-content">
        <div class="slide-image-container">
          <img [src]="slide.imageSrc" [alt]="slide.imageAlt" />
        </div>
        <div class="slide-text-container">
          <h1 class="ds-title-2">{{ slide.heading | translate }}</h1>
          <p class="ds-ui-1" [innerHTML]="slide.paragraph | translate"> </p>
          <app-ds-button variant="primary" [isLoading]="isLoading" [width]="slide.id === slides.length ? 'full' : 'auto'" (clicked)="goToNextSlide()">
            {{ slide.cta | translate }}
          </app-ds-button>
        </div>
      </div>
    </swiper-slide>
  }
</swiper-container>
